import { environment } from '@env/environment';

declare let window;

export class FroalaEditorOptions {
  key: string;
  charCounterCount?: boolean;
  codeMirror: any;
  heightMin?: number;
  toolbarButtons?: Array<string>;
  pluginsEnabled: Array<string>;

  constructor() {
    this.key = environment.froalaEditorKey;
    this.charCounterCount = false;
    this.codeMirror = window.CodeMirror;
    this.heightMin = 200;
    this.pluginsEnabled = ['link', 'codeView'];
    this.toolbarButtons = [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      '|',
      'fontSize',
      'paragraphFormat',
      '|',
      'align',
      'formatOL',
      'formatUL',
      'quote',
      '|',
      'outdent',
      'indent',
      '|',
      'selectAll',
      'clearFormatting',
      '|',
      'undo',
      'redo',
      '|',
      'html'
    ];
  }
}
